import {validateDatoCmsTypes} from './common.serde'
import {parseFontAwesomeIcon} from './icon.serde'
import {parseCallToAction} from './call-to-action.serde'
import {
  ComponentDropdownMenuFieldsFragment,
  ComponentDropdownMenuItemFieldsFragment,
} from '../../../../__generated__/datocms.types'
import {DropdownMenu, DropdownMenuItem} from '../types/dropdown-menu.types'

export function parseDropdownMenu(a: ComponentDropdownMenuFieldsFragment): DropdownMenu {
  const dropdownMenu = validateDatoCmsTypes(a)

  return {
    title: dropdownMenu.title,
    icon: parseFontAwesomeIcon(dropdownMenu.icon),
    slug: dropdownMenu.slug,
    children: dropdownMenu.childrenField?.map(i => parseDropdownMenuItem(i!)),
  }
}

function parseDropdownMenuItem(a: ComponentDropdownMenuItemFieldsFragment): DropdownMenuItem {
  const item = validateDatoCmsTypes(a)

  return {
    title: item.title,
    icon: item.icon ? parseFontAwesomeIcon(item.icon) : undefined,
    link: parseCallToAction(item.link),
    children: item.childrenField?.map(i => parseDropdownMenuItem({...i, childrenField: []})),
  }
}
